module.exports = __webpack_public_path__ + "img/iconfont.70910e29.svg";